import React from 'react';
import {useTranslation} from 'react-i18next';
import {s} from '@/app/utils/s';
import Space, {spaceSizes} from '@/app/components/Space';
import AuthTitle from '@/app/features/auth/components/auth_title';
import Button from "@/app/components/button";
import OTPInput from "@/app/components/otp_input";
import useOtp from "@/app/features/auth/pages/verification/slice";
import styles from "@/app/features/auth/pages/verification/styles.module.scss";
import ErrorLine from "@/app/components/error_line/widget";

const VerificationWidget = () => {
  const {t} = useTranslation();
  const {
    code,
    setCode,
    loading,
    error,
    verification,
    codeContainAllDigits,
    timer,
    startTimer,
    getTimeString
  } = useOtp();

  return (
    <div className={styles.main}>
      <AuthTitle title={t(s.verification)} subtitle={t(s.enterTheFourDigitCode)}/>
      <Space h={spaceSizes.s50}/>
      <OTPInput length={4} onComplete={setCode}/>
      <Space h={spaceSizes.s20}/>
      <Button
        isLoading={loading}
        isDisabled={codeContainAllDigits()}
        onClick={verification}
      >
        {t(s.continue)}
      </Button>
      <Space h={spaceSizes.s14}/>
      <ErrorLine className={styles.errorLine} error={error}/>
      <Space h={spaceSizes.s16}/>
      <div className={styles.footerWrap}>
        <div>{t(s.didNotGetTheCode)} </div>
        <div onClick={startTimer} className={styles.sendAgain}>{timer !== 0 ? getTimeString() : t(s.sendAgain)}</div>
      </div>
    </div>
  );
};

export default VerificationWidget;